import React from 'react'
import { Paper, withStyles } from '@material-ui/core'

function CardPaper({ classes, ...props }) {
  return (
    <Paper
      className={classes.root}
      elevation={2}
      square
      {...props}
    />
  )
}

const styles = theme => ({
  root: {
    padding: theme.spacing(2),
    minWidth: 'fit-content',
    height: '100%'
  }
})

export default withStyles(styles)(CardPaper)